module.exports = __webpack_public_path__ + "58713b566cfe62d71c5f04b13662c77b.png";